import { useMutation } from "@tanstack/react-query";
import { ClientInferResponseBody } from "@ts-rest/core";
import { apiContract } from "tekkr-common/dist/model/api/api.contract";
import { OrgSelector, useOrgController } from "../../auth/org-provider";
import { useAuthController } from "../../auth/auth-provider";
import { apiClient } from "../service/tekkr-service";

interface Input {
    orgName: string;
}

interface Options {
    onSuccess?: () => void;
}

export function useCreateOrgMutation(options?: Options) {
    const authController = useAuthController();
    const orgController = useOrgController();
    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.createOrg({
                body: {
                    name: input.orgName,
                },
            });
            const body = res.body as ClientInferResponseBody<typeof apiContract.createOrg, 201>;
            await authController.refetch();
            OrgSelector.setSelectedOrg(body.id);
            await orgController.refetch();
        },
        onSuccess: options?.onSuccess,
    });
}
